import React, { Fragment, useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
// import { Breadcrumb } from "react-bootstrap";
import EnquiriesList from "../components/custom/EnquiriesList";
import ReservationCalendar from "../components/custom/ReservationCalendar";

// import { FiPlus, FiMoreVertical } from "react-icons/fi";
import { FiSettings } from "react-icons/fi";
import { FaPlus } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";

import GlobalSearch from "../components/custom/scheduler2/GlobalSearch";

function TableReservation() {
  // const fabRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [view, setView] = useState("calendar");
  // const [fabOpen, setFabOpen] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const isSchedulerRoute = location.pathname.startsWith("/scheduler");
    const wantsList =
      !isSchedulerRoute &&
      (params.has("tab") ||
        params.has("date") ||
        location.pathname.startsWith("/table-enquiry-list"));

    if (isSchedulerRoute) {
      setView("calendar");
      window.sessionStorage.setItem("activeTab", "calendar");
      return;
    }

    if (wantsList) {
      setView("list");
      window.sessionStorage.setItem("activeTab", "list");
      return;
    }

    const selected = window.sessionStorage.getItem("activeTab");
    if (selected) {
      setView(selected);
    }
  }, [location.search, location.pathname]);

  const setActiveView = (next) => {
    setView(next);
    window.sessionStorage.setItem("activeTab", next);
    navigate(next === "calendar" ? "/scheduler" : "/table-enquiry-list");
  };

  return (
    <Fragment>
      <MasterLayout>
        {/* <Breadcrumb title="Table Reservation" /> */}
        <div className="tr-page">
          {/* <h1 className="tr-page__title">Reservations</h1> */}
          <div className="tr-page__header">
            <div className="tr-page__tabs" role="tablist" aria-label="View">
              <button
                type="button"
                role="tab"
                className={
                  view === "calendar"
                    ? "tr-page__tab is-active"
                    : "tr-page__tab"
                }
                aria-selected={view === "calendar"}
                onClick={() => setActiveView("calendar")}
              >
                Scheduler
              </button>
              <button
                type="button"
                role="tab"
                className={
                  view === "list" ? "tr-page__tab is-active" : "tr-page__tab"
                }
                aria-selected={view === "list"}
                onClick={() => setActiveView("list")}
              >
                List
              </button>

              {/* Previous toggle switch (kept for reference)
              <label className="view-switch" aria-label="Toggle view">
                <input
                  type="checkbox"
                  className="view-switch__input"
                  checked={view === "list"}
                  onChange={(e) => {
                    setView(e.target.checked ? "list" : "calendar");
                    window.sessionStorage.setItem(
                      "activeTab",
                      e.target.checked ? "list" : "calendar"
                    );
                  }}
                  role="switch"
                  aria-checked={view === "list"}
                />
                <span className="view-switch__track">
                  <span className="view-switch__thumb" />
                  <span className="view-switch__text view-switch__text--left">
                    Scheduler
                  </span>
                  <span className="view-switch__text view-switch__text--right">
                    List
                  </span>
                </span>
              </label>
              */}
            </div>

            <div className="tr-page__actions">
              <button
                type="button"
                className="tr-page__icon-btn"
                onClick={() => navigate("/reservation-settings")}
                aria-label="Settings"
                title="Settings"
              >
                <FiSettings />
              </button>
              <button
                type="button"
                className="tr-page__add-btn"
                onClick={() => navigate("/add-reservation")}
              >
                <FaPlus />
                <span>Add</span>
              </button>

              {/* Previous FAB menu (kept for reference)
              <div
                className={`fab-menu ${fabOpen ? "fab-menu--open" : ""}`}
                ref={fabRef}
              >
                <button
                  type="button"
                  className={!fabOpen ? "fab-menu__main" : "fab-menu__main rotate"}
                  onClick={() => setFabOpen((o) => !o)}
                  aria-label="Open actions"
                >
                  <FaPlus />
                </button>
                <div className="fab-menu__list">
                  <button
                    type="button"
                    className="fab-menu__item"
                    onClick={() => navigate("/add-reservation")}
                  >
                    <span className="fab-menu__icon">
                      <FiPlus />
                    </span>
                    <span className="fab-menu__label">Add reservation</span>
                  </button>
                  <button
                    type="button"
                    className="fab-menu__item"
                    onClick={() => navigate("/reservation-settings")}
                  >
                    <span className="fab-menu__icon">
                      <FiSettings />
                    </span>
                    <span className="fab-menu__label">Settings</span>
                  </button>
                </div>
              </div>
              */}
            </div>
          </div>

          <div className="tr-page__search">
            <GlobalSearch />
          </div>
        </div>

        {view === "calendar" ? <ReservationCalendar /> : <EnquiriesList />}
      </MasterLayout>
    </Fragment>
  );
}

export default TableReservation;
